import { render, staticRenderFns } from "./Skill.vue?vue&type=template&id=1ab5c1df&scoped=true"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"
import style1 from "./Skill.vue?vue&type=style&index=1&id=1ab5c1df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab5c1df",
  null
  
)

export default component.exports